import { subscribedRelationshipOwners } from '@griply/services';
import { useQuery } from '@tanstack/react-query';
import { createSubscriptionQuery } from 'shared/lib/@tanstack-query';
import { getRelationships } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const queryKey = 'relationships';

// One listener per live owner kind, fanned in under one key; task-owned docs stay out of the set.
const relationshipQueries = subscribedRelationshipOwners.map(
  (owner) => () => getRelationships(owner),
);

export const useRelationshipsQuery = (uid: ID | undefined, enabled = true) =>
  useQuery({
    queryKey: [queryKey, uid ?? ''],
    queryFn: createSubscriptionQuery(relationshipQueries),
    enabled: !!uid && enabled,
  });
